import { 
    IonContent, 
    IonHeader, 
    IonPage, 
    IonTitle, 
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    IonInput,
    IonButton,
    IonText,
    useIonViewWillEnter,
    IonImg
} from '@ionic/react';
import React, { useState, Component }  from 'react';
import { LANGUAGE, GetStr } from "../language/Language";
import { hideTab } from "../components/Tabs";
import NServer from "../components/NServer";
import { showAlert } from '../components/Alert';


const ForgetPassword: React.FC = () => {

    const [email, setEmail] = useState("");
    const [valid, setValid] = useState(false);

    useIonViewWillEnter(() => {
        hideTab();
    });

    // handle the user input
    const updateEmail = (e : any ) : void => {
        let val = e.detail.value.toString();
        setEmail(val);
        
        let emailValid = val.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) != null;
        setValid(emailValid);
    };

    const submit = async () => {
        const state = {
            email : email
        }

        var server = new NServer();
        await server.sendForm("forget_password", state);
        
        if (!server.success && server.message != "")
            showAlert(server.message);
    };

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="login" />
                    </IonButtons>
                </IonToolbar>
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-padding" size-lg="8" size="12">
                            <h3 className="title"><IonText>{ GetStr(LANGUAGE.TXT_FORGET_PASSWORD_TITLE) }</IonText></h3>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-padding" size-md="2" size="5">
                            <IonImg src="/assets/img/forget_pass_pic.png" />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-padding" size-md="8" size-lg="6" size-xl="4" size="12">
                            <div className="center-flex">
                                <IonGrid className="ion-no-margin">
                                    <form action="post">
                                        <IonRow>
                                            <IonCol>
                                                <div>{ GetStr(LANGUAGE.TXT_FORGET_PASSWORD_DESC) }</div>
                                            </IonCol>
                                        </IonRow> 
                                        <IonRow>
                                            <IonCol>
                                                <IonItem color="none">
                                                    <IonLabel position="floating">
                                                        { GetStr(LANGUAGE.TXT_EMAIL) }
                                                    </IonLabel>
                                                    <IonInput onIonChange={updateEmail}/>
                                                </IonItem>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow className="ion-padding-top">
                                            <IonCol className="ion-padding">
                                                <IonButton className="main-but" color="primary" expand="block" onClick={submit} disabled={!valid}>
                                                    { GetStr(LANGUAGE.TXT_SEND_RESET_MAIL) }
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    </form>
                                </IonGrid>
                            </div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default ForgetPassword;
